import { useEffect, useState } from "react";
import style from "./EmployeeSettings.module.css";
import { useParams } from "react-router-dom"; // ✅ fixed import
import EmployeeNavBar from "../Navbar/EmployeeNavbar";
import BreadCrumb from "../../../components/BreadCrumb/BreadCrumb";

export default function EmployeeSettings() {
    const { employeeId } = useParams();

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        dob: "",
        gender: "",
        position: "",
        teamName: "",
        phone: "",
        altPhone: "",
        address: "",
        linkedin: "",
        github: "",
        x: "",
        email: "",
        password: "",
    });

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const apiurl = process.env.REACT_APP_SERVER_URL;
    const token = localStorage.getItem("token");

    // fetch user details
    useEffect(() => {
        async function fetchUser() {
            try {
                const res = await fetch(`${apiurl}/employee-dashboard/${employeeId}`, {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    }
                });
                if (!res.ok) throw new Error("Failed to fetch user data");

                const data = await res.json();
                const user = data.user;

                setFormData({
                    firstName: user.firstName || "",
                    lastName: user.lastName || "",
                    dob: user.dob ? user.dob.split("T")[0] : "",
                    gender: user.gender || "",
                    position: user.position || "",
                    teamName: user.teamName || "",
                    phone: user.phonePrimary?.toString() || "",
                    altPhone: user.phoneSecondary?.toString() || "",
                    address: user.address || "",
                    linkedin: user.socialLinks?.linkedIn || "",
                    github: user.socialLinks?.github || "",
                    x: user.socialLinks?.x || "",
                    email: user.email || "",
                    password: "", // don't prefill password
                });

                setLoading(false);
            } catch (err) {
                setError("Failed to load user data");
                setLoading(false);
            }
        }

        if (employeeId) fetchUser();
    }, [apiurl, employeeId, token]);

    function handleChange(e) {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    }

    async function handleSubmit(e) {
        e.preventDefault();

        // ✅ build payload to match backend schema
        const payload = {
            firstName: formData.firstName,
            lastName: formData.lastName,
            dob: formData.dob,
            gender: formData.gender,
            position: formData.position,
            teamName: formData.teamName,
            phonePrimary: formData.phonePrimary,
            phoneSecondary: formData.phoneSecondary,
            address: formData.address,
            socialLinks: {
                linkedIn: formData.linkedin,
                github: formData.github,
                x: formData.x,
            },
            password: formData.password,
        };

        try {
            const res = await fetch(`${apiurl}/employee-dashboard/${employeeId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });

            const data = await res.json();

            if (res.ok) {
                alert("Profile updated successfully!");
            } else {
                alert(data.message || "Failed to update profile");
            }
        } catch (error) {
            alert("Something went wrong while updating");
        }
    }

    return (
        <div className="container mb-4">
            <EmployeeNavBar />

            <div className={style.setting}>

                <div className="pt-3 pb-0 mt-lg-1 ps-lg-4 ms-lg-5 pb-lg-0">
                    <BreadCrumb
                        link={`/employee-dashboard/${employeeId}`}
                        name="Dashboard"
                        icon={true}
                    />
                    <BreadCrumb
                        link={`/employee-dashboard/${employeeId}/settings`}
                        name={` Update Your Profile For ${employeeId}`}
                        icon={false}
                    />

                </div>

                {loading && <p className="text-success">{loading}</p>}
                {error && <p className="text-danger">{error}</p>}

                <div className={` ${style.settingsPage}`}>
                    <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                            {/* First and Last Name */}
                            <div className="col-6 col-md-6">
                                <input
                                    type="text"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    className={`form-control ${style.input}`}
                                    placeholder="Enter first name"
                                />
                            </div>
                            <div className="col-6 col-md-6">
                                <input
                                    type="text"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    className={`form-control ${style.input}`}
                                    placeholder="Enter last name"
                                />
                            </div>

                            {/* Email and DOB */}
                            <div className="col-6 col-md-6">
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    className={`form-control ${style.input}`}
                                    placeholder="Enter email"
                                    disabled
                                />
                            </div>
                            <div className="col-6 col-md-6">
                                <input
                                    type="date"
                                    name="dob"
                                    value={formData.dob}
                                    onChange={handleChange}
                                    className={`form-control ${style.input}`}
                                />
                            </div>

                            {/* Gender, Position, Team */}
                            <div className="row  mt-3">
                                <div className="col-4 col-lg-4  mt-1">
                                    <select
                                        name="gender"
                                        value={formData.gender}
                                        onChange={handleChange}
                                        className={`form-select ${style.formSelect}`}
                                        required
                                    >
                                        <option value="">Select Gender</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>

                                {/* position */}
                                <div className="col-4 col-lg-4 mt-1">

                                    <select
                                        name="position"
                                        className={`form-select ${style.formSelect} w-100 `}
                                        value={formData.position}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">position</option>
                                        <option value="Head Admin">Head Admin</option>
                                        <option value="Junior Admin">Junior Admin</option>
                                        <option value="Head Manager">Head Manager</option>
                                        <option value="Hr">Hr</option>
                                        <option value="Front End Developer">Front End Developer</option>
                                        <option value="UI Designer">UI Designer</option>
                                        <option value="React Developer">React Developer</option>
                                        <option value="NodeJS Developer">NodeJS Developer</option>
                                        <option value="MERN Developer">MERN Developer</option>
                                        <option value="MEAN Developer">MEAN Developer</option>
                                        <option value="Database Developer">Database Developer</option>
                                        <option value="Manual Tester">Manual Tester</option>
                                        <option value="Automation Tester">Automation Tester</option>
                                    </select>
                                </div>

                                {/* team name  */}
                                <div className="col-4 col-lg-4 mt-1">
                                    <select
                                        name="teamName"
                                        className={`form-select ${style.formSelect}`}
                                        value={formData.teamName}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Team</option>
                                        <option value="Admin Team">Admin Team</option>
                                        <option value="Management Team">Management Team</option>
                                        <option value="Hr Team">Hr Team</option>
                                        <option value="Front End Developement">Front End Developement</option>
                                        <option value="UI/UX Desgin">UI/UX Desgin</option>
                                        <option value="Back End Developement">Back End Developement</option>
                                        <option value="Full Stack Development">Full Stack Development</option>
                                        <option value="DevOps">DevOps</option>
                                        <option value="Q/A Testing">Q/A Testing</option>
                                    </select>
                                </div>
                            </div>

                            {/* Phone */}
                            <div className="col-6 col-md-6">
                                <input
                                    type="text"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    className={`form-control ${style.input}`}
                                    placeholder="Enter phone number"
                                />
                            </div>

                            {/* Alternate Phone */}
                            <div className="col-6 col-md-6">
                                <input
                                    type="text"
                                    name="altPhone"
                                    value={formData.altPhone}
                                    onChange={handleChange}
                                    className={`form-control ${style.input}`}
                                    placeholder="Enter alternate phone"
                                />
                            </div>

                            {/*  Address  */}
                            <div className="col-12 col-md-12">
                                <input
                                    type="text"
                                    name="address"
                                    value={formData.address}
                                    onChange={handleChange}
                                    className={`form-control ${style.input}`}
                                    placeholder="Enter address"
                                />
                            </div>

                            {/* social links */}
                            <div className="d-md-none d-lg-none d-xl-none">
                                <div className="row">

                                    <div className="col-6 col-md-4">
                                        <input
                                            type="text"
                                            name="linkedin"
                                            value={formData.linkedin}
                                            onChange={handleChange}
                                            className={`form-control ${style.input}`}
                                            placeholder="LinkedIn profile"
                                        />
                                    </div>
                                    <div className="col-6">
                                        <input
                                            type="text"
                                            name="github"
                                            value={formData.github}
                                            onChange={handleChange}
                                            className={`form-control ${style.input}`}
                                            placeholder="GitHub profile"
                                        />
                                    </div>
                                    <div className="col-6 col-md-4 mt-3">
                                        <input
                                            type="text"
                                            name="x"
                                            value={formData.x}
                                            onChange={handleChange}
                                            className={`form-control ${style.input}`}
                                            placeholder="X handle"
                                        />
                                    </div>
                                    <div className="col-6  mt-3">
                                        <input
                                            type="password"
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            className={`form-control ${style.input}`}
                                            placeholder="Enter new password"
                                        />
                                    </div>
                                </div>

                            </div>

                            {/* Social Links */}
                            <div className=" d-none d-lg-block mt-lg-3">
                                <div className="row">

                                    <div className=" col-6 col-md-4 col-lg-4">
                                        <input
                                            type="text"
                                            name="linkedin"
                                            value={formData.linkedin}
                                            onChange={handleChange}
                                            className={`form-control ${style.input}`}
                                            placeholder="LinkedIn profile"
                                        />
                                    </div>
                                    <div className="col-md-4 col-lg-4">
                                        <input
                                            type="text"
                                            name="github"
                                            value={formData.github}
                                            onChange={handleChange}
                                            className={`form-control ${style.input}`}
                                            placeholder="GitHub profile"
                                        />
                                    </div>
                                    <div className="col-md-4 col-lg-4">
                                        <input
                                            type="text"
                                            name="x"
                                            value={formData.x}
                                            onChange={handleChange}
                                            className={`form-control ${style.input}`}
                                            placeholder="X handle"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="text-center mt-4">
                            <button type="submit" className="btn btn-sm btn-primary px-4">
                                Save Changes
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
